export default __webpack_public_path__ + "static/media/i_bus-gen_yl_tagless.7d92175d.svg";